// tslint:disable max-line-length
import React, { useEffect, useState } from 'react';
import {
  fiveDays,
  actionPlan,
  actionPlanArchive,
  cv,
  CompletingQuiz,
  quizArchive,
  newsFeed,
  newsFeedArchive,
  profile,
  selfAssessmentAndAP,
  selfAssessmentAndAPArchive,
  selfAssessment,
  selfAssessmentArchive,
  starEmployee,
  watchingVideo,
  watchingVideoArchive,
  getMonthImage,
} from '../../utils/images';
import styled from 'styled-components';
import { getItem } from '../../utils/localStorage';
import { sortingData } from '../../helpers/sort';
import Icon from 'lqa-ui/lib/Components/Icon';

const CardContentContainer = styled('div')`
  box-sizing: border-box;
  width: 95%;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: left;
  row-gap: 1rem;
  padding: 0.5rem 0.5rem 1rem 0.5rem;

  h3 {
    margin-bottom: 0px;
  }
`;
const Card = styled('div')`
  padding: 12px;
  display: flex;
  box-shadow:
    0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13),
    0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
  &.archive-Card {
    justify-content: space-between;
    height: 100px;
  }
  .montlyColor {
    width: 80%;
    height: 90px;
    object-fit: cover;
    z-index: -99px;
    position: absolute;
  }
`;
const TextContainer = styled('div')`
  z-index: 1;
  color: #1f1f1f;
  position: relative;
  font-family: Source Sans Pro;
  font-size: 1.375rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.75rem;
  top: 12px;
  left: 12px;
`;
const MonthlyCardContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  row-gap: 20px;
  column-gap: 20px;
  margin-top: 20px;
`;

const MonthlyCard = styled('div')`
  padding: 12px;
  display: flex;
  width: 40%;
  flex-direction: column;
  box-shadow:
    0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13),
    0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
  position: relative;
  top: 0;
  left: 0;
`;
const AchivementHeading = styled('h3')`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  text-align: left;
  color: #1f1f1f;
`;

const MonthlyDetailContainer = styled('div')`
  padding-top: 13px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  gap: 13px;
  div {
    display: flex;
    justify-content: space-between;
  }
  h3 {
    color: #031c38;
    font-family: Source Sans Pro;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
  }
  p {
    color: #071c3e;
    font-family: Source Sans Pro;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }
  label {
    padding-top: 13px;

    color: #4fada6;
    font-family: Source Sans Pro;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    padding-left: 10px;
  }

  .progressbar-container {
    display: flex;
    justify-content: flex-start;
  }
  .progressbar {
    margin-top: 2.5px;
  }

  progress {
    display: block;
    width: 180px;
    background: #f1f1f1;
    border-radius: 14px;
    height: 13px;
  }
  .progressbar-container.border-radius-show progress::-moz-progress-value {
    border-radius: 12px !important;
  }
  .progressbar-container.border-radius-show progress::-webkit-progress-value {
    border-radius: 12px !important;
  }
  progress::-moz-progress-bar {
    background: #4fada6;
    border-radius: 12px 0px 0px 12px;
  }

  progress::-webkit-progress-bar {
    background: transparent;
  }

  progress::-webkit-progress-value {
    background: #4fada6;
    border-radius: 12px 0px 0px 12px;
  }
`;
const DetailContainer = styled('div')`
  padding-left: 22px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  div {
    display: flex;
    justify-content: space-between;
  }
  h3 {
    color: #031c38;
    font-family: Source Sans Pro;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    margin-bottom: 17px;
  }
  p {
    color: #071c3e;
    font-family: Source Sans Pro;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }
  label {
    color: #4fada6;
    font-family: Source Sans Pro;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    padding-left: 10px;
  }

  .progressbar-container {
    display: flex;
    justify-content: flex-start;
  }
  .progressbar {
    margin-top: 2.5px;
  }

  progress {
    display: block;
    width: 180px;
    background: #f1f1f1;
    border-radius: 14px;
    height: 13px;
  }
  .progressbar-container.border-radius-show progress::-moz-progress-value {
    border-radius: 12px !important;
  }
  .progressbar-container.border-radius-show progress::-webkit-progress-value {
    border-radius: 12px !important;
  }
  progress::-moz-progress-bar {
    background: #4fada6;
    border-radius: 12px 0px 0px 12px;
  }

  progress::-webkit-progress-bar {
    background: transparent;
  }

  progress::-webkit-progress-value {
    background: #4fada6;
    border-radius: 12px 0px 0px 12px;
  }
`;
const Title = styled('div')`
  color: #4fada6;
  font-family: Source Sans Pro;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`;
const ImageContainer = styled('img')`
  height: 90px;
  width: 90px;
`;
const ImageMainContainer = styled('img')`
  position: absolute;
  top: 19px;
  left: 19px;
  height: 74px;
  width: 74px;
`;
const ImageBackGroundContainer = styled('img')`
  position: relative;
  height: 90px;
  width: 90px;
  top: 0;
  left: 0;
`;

const Tag = styled('div')`
  color: #919191;
  text-align: center;
  font-family: Source Sans Pro;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  border: 1px solid #919191;
  border-radius: 16px;
  padding: 5px;
  &.width-auto {
    width: fit-content;
    display: block;
    color: #4fada6;
    border-color: #4fada6;
  }
`;

const MonthlyCardComponent = ({ image, data, isShowBackgroudImage }) => {
  return (
    <MonthlyCard>
      <ImageBackGroundContainer src={data.archive ? image : data.image} />

      {isShowBackgroudImage && data.archive ? (
        <ImageMainContainer src={data.archive} />
      ) : null}

      <MonthlyDetailContainer>
        {((data.isShowProgress &&
          data.subTitle >= data.streak &&
          data.activityType === 'LoginPoint') ||
          data.activityType !== 'LoginPoint') && (
          <Tag className="width-auto">{data.totalPoint} Points</Tag>
        )}
        <Title>{data.key}</Title>
        <h3>{data.title}</h3>
      </MonthlyDetailContainer>
    </MonthlyCard>
  );
};

const AchivementCard = ({ data }) => {
  const userProfile = getItem('userProfile');
  const shortingOrder = [
    'LoginPoint',
    'OverallLQA',
    'QuizPoint',
    'MembershipPoint',
    'CVPoint',
    'VideoPoint',
    'NewsPoint',
    'CreateSA',
    'CreateAP',
    'StarEmployee',
    'CompleteSA',
    'CompleteAP',
  ];

  const [achivmentData, setAchivmentData] = useState<any[]>([]);
  const [monthlyData, setMonthlyData] = useState<any>();
  const [entityData, setEntityData] = useState<any>();
  const [showArchiveData, SetShowArchiveData] = useState(false);
  const currentMonth = new Date().getMonth() + 1;
  const [selectedMonth, setSelectedMonth] = useState<number | any>();
  const months = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  interface GetTitleProps {
    image?: string;
    count?: number;
    activityType?: string;
    subTitle?: string | number;
    title?: string;
    sum?: number;
    key?: string;
    archive?: string;
  }
  const getTitle = (
    activityType: string,
    numberQuizzes: number
  ): GetTitleProps => {
    switch (activityType) {
      case 'LoginPoint':
        return {
          image: fiveDays,
          key: '',
          title: `Reach a 5 day streak`,
          subTitle: 5,
        };
      case 'MembershipPoint':
        return {
          image: profile,
          key: `Welcome to myLQA`,
          title: 'myLQA Membership',
          subTitle: 'Created myLQA Membership',
        };

      case 'VideoPoint':
        return {
          image: watchingVideo,
          archive: watchingVideoArchive,
          key: `Learning Guru`,
          title: `Watching Learning Videos`,
          subTitle: numberQuizzes,
        };
      case 'QuizPoint':
        return {
          image: CompletingQuiz,
          archive: quizArchive,
          key: 'Quiz Warrior',
          title:
            numberQuizzes <= 1
              ? `${numberQuizzes} Quiz Completed`
              : `${numberQuizzes} Quizzes Completed`,
          subTitle: numberQuizzes,
        };

      case 'NewsPoint':
        return {
          image: newsFeed,
          archive: newsFeedArchive,
          key: 'Luxury Bookworm',
          title: `Reading Newsfeed Items`,
          subTitle: numberQuizzes,
        };

      case 'StarEmployee':
        return {
          image: starEmployee,
          key: 'You’re a Star',
          title: `Awarded Star Employee`,
          subTitle: '',
        };

      case 'CompleteAP':
        return {
          image: selfAssessmentAndAP,
          archive: selfAssessmentAndAPArchive,
          key: 'Action plan Intiator',
          title: `Completing Action Plan`,
          subTitle: numberQuizzes,
        };

      case 'CompleteSA':
        return {
          image: selfAssessmentAndAP,
          archive: selfAssessmentAndAPArchive,
          key: 'Assessment Champion',
          title: `Completing Self-Assessments`,
          subTitle: numberQuizzes,
        };
      case 'CVPoint':
        return {
          image: cv,
          key: 'Professional History',
          title: 'myLuxury CV',
          subTitle: `Updated Professional CV`,
        };

      default:
        return {};
    }
  };
  const getCount = (countData, activity) => {
    return countData &&
      countData.length > 0 &&
      data.find((item) => item.activityType === activity)
      ? Number(data.find((item) => item.activityType === activity).count)
      : 0;
  };
  const getSum = (sumData, activity) => {
    return sumData &&
      sumData.length > 0 &&
      sumData.find((item) => item.activityType === activity)
      ? Number(data.find((item) => item.activityType === activity).sum)
      : 0;
  };
  const groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  const setData = (
    image,
    archive,
    activityType,
    totalPoint,
    title,
    subTitle,
    key,
    isShowProgress,
    streak,
    month
  ) => {
    return {
      image,
      archive,
      activityType,
      totalPoint,
      title,
      subTitle,
      key,
      isShowProgress,
      streak,
      month,
    };
  };
  useEffect(() => {
    const streak = 5;
    const monthData1 = data.filter((item) => item.month !== undefined);
    const entityData1 = data.filter((item) => !item.month);
    const resultMonth = groupBy(monthData1, 'month');

    const archivedMontData: any = {};
    for (const [key, value] of Object.entries(resultMonth)) {
      if (value && Array.isArray(value) && value.length > 0) {
        const updatedMonthData: any = [];
        if (
          value.find((item) => item.activityType === 'CreateAP') ||
          value.find((item) => item.activityType === 'DeleteAP')
        ) {
          const totalPoint =
            getSum(value, 'CreateAP') - Math.abs(getSum(value, 'DeleteAP'));
          const totalCount =
            getCount(value, 'CreateAP') - Math.abs(getCount(value, 'DeleteAP'));
          const newData = setData(
            actionPlan,
            actionPlanArchive,
            'CreateAP',
            totalPoint,
            'Creating Action Plan',
            totalCount,
            'Action plan Intiator',
            true,
            streak,
            key
          );
          if (totalPoint > 0) {
            updatedMonthData.push(newData);
          }
        }
        if (
          value.find((item) => item.activityType === 'CreateSA') ||
          value.find((item) => item.activityType === 'DeleteSA')
        ) {
          const totalPoint =
            getSum(value, 'CreateSA') - Math.abs(getSum(value, 'DeleteSA'));
          const totalCount =
            getCount(value, 'CreateSA') - Math.abs(getCount(value, 'DeleteSA'));
          const newData = setData(
            selfAssessment,
            selfAssessmentArchive,
            'CreateSA',
            totalPoint,
            'Creating Self-Assessments',
            totalCount,
            'Assessment Whiz',
            true,
            streak,
            key
          );
          if (totalPoint > 0) {
            updatedMonthData.push(newData);
          }
        }
        if (
          value.find(
            (item) =>
              item.activityType === 'DepartmentLQA' ||
              item.activityType === 'NonDepartmentLQA'
          )
        ) {
          const overallLQaItem = value.filter(
            (item) =>
              item.activityType === 'DepartmentLQA' ||
              item.activityType === 'NonDepartmentLQA'
          );
          for (const v of overallLQaItem) {
            const totalPoint =
              getSum(overallLQaItem, 'DepartmentLQA') +
              getSum(overallLQaItem, 'NonDepartmentLQA');

            const newData = setData(
              selfAssessment,
              selfAssessmentArchive,
              'OverallLQA',
              totalPoint,
              'LQA Assessment Points',
              'Score + Emotional Rating - ' + v.name,
              'Departmental Assessment Score',
              true,
              5,
              v.month
            );
            if (totalPoint > 0) {
              updatedMonthData.push(newData);
            }
          }
        }

        const filterData = value.filter(
          (item) =>
            item.activityType !== 'CreateAP' &&
            item.activityType !== 'DeleteAP' &&
            item.activityType !== 'CreateSA' &&
            item.activityType !== 'DeleteSA' &&
            item.activityType !== 'DepartmentLQA' &&
            item.activityType !== 'NonDepartmentLQA' &&
            item.activityType !== 'OverallLQA'
        );
        if (filterData) {
          filterData.map(
            (item: {
              image: string;
              count: number;
              activityType: string;
              subTitle: string;
              title: string;
              sum: 0;
              key: string;
            }) => {
              const image = getTitle(item.activityType, item.count).image || '';
              const archiveImage =
                getTitle(item.activityType, item.count).archive || '';
              const title = getTitle(item.activityType, item.count).title || '';
              const subtitle =
                getTitle(item.activityType, item.count).subTitle || '';
              const keyTitle = getTitle(item.activityType, item.sum).key;
              if (title && subtitle !== 0) {
                const newData = setData(
                  image,
                  archiveImage,
                  item.activityType,
                  item.sum,
                  title,
                  subtitle,
                  keyTitle,
                  true,
                  streak,
                  key
                );
                if (item.sum > 0) {
                  updatedMonthData.push(newData);
                }
              }
            }
          );
        }

        archivedMontData[key] = updatedMonthData;
      }
    }

    const newEntityData: any = [];

    const dt = entityData1.filter((item) => item.activityType === 'OverallLQA');
    for (const v of dt) {
      const newData = setData(
        selfAssessment,
        selfAssessmentArchive,
        'OverallLQA',
        v.sum,
        ' Assessment Score',
        'Score + Emotional Rating',
        ' Assessment Score',
        false,
        5,
        0
      );
      newEntityData.push(newData);
    }
    const temp = entityData1.filter(
      (item) => item.activityType !== 'OverallLQA'
    );
    const otherEntity: any = [];
    for (const item of temp) {
      const image = getTitle(item.activityType, item.count).image || '';
      const archiveImage =
        getTitle(item.activityType, item.count).archive || '';
      const title = getTitle(item.activityType, item.count).title || '';
      const subtitle = getTitle(item.activityType, item.count).subTitle || '';
      const keyTitle = getTitle(item.activityType, item.sum).key;

      if (title && subtitle !== 0) {
        const newData: any = setData(
          image,
          archiveImage,
          item.activityType,
          item.sum,
          title,
          subtitle,
          keyTitle,
          true,
          streak,
          0
        );
        otherEntity.push(newData);
      }
    }
    const loginData: any = [];
    const loginPoint = 50;
    if (userProfile && userProfile.loginCounter) {
      const newData = setData(
        fiveDays,
        null,
        'LoginPoint',
        loginPoint,
        'Reach a ' + streak + ' day Streak',
        userProfile.loginCounter,
        'On a Streak',
        true,
        5,
        0
      );
      loginData.push(newData);
    }
    let CurrentMonthAchivementData: any = [];
    const PreviousMonthAchivementData: any = {};
    for (const [k, v] of Object.entries(archivedMontData)) {
      if (v && Array.isArray(v)) {
        if (Number(k) === currentMonth) {
          v.map(
            (value: any) =>
              value.activityType !== 'LoginPoint' &&
              CurrentMonthAchivementData.push(value)
          );
        } else {
          PreviousMonthAchivementData[k] = sortingData(
            v,
            shortingOrder,
            'activityType'
          );
        }
      }
    }
    CurrentMonthAchivementData = sortingData(
      CurrentMonthAchivementData,
      shortingOrder,
      'activityType'
    );
    setAchivmentData([...loginData, ...CurrentMonthAchivementData]);
    setMonthlyData(PreviousMonthAchivementData);
    setEntityData([...otherEntity, ...newEntityData]);
  }, [data]);

  const handleSetMonthData = (key) => {
    if (Number(key) !== selectedMonth) {
      setSelectedMonth(Number(key));
    }
  };
  return (
    <CardContentContainer>
      <AchivementHeading> Achievements </AchivementHeading>
      {achivmentData &&
        achivmentData.length > 0 &&
        achivmentData.map((item: any) => (
          // tslint:disable-next-line:jsx-key
          <Card>
            <ImageContainer src={item.image} />
            <DetailContainer>
              <div>
                <Title>{item.key}</Title>
                {((item.isShowProgress &&
                  item.subTitle >= item.streak &&
                  item.activityType === 'LoginPoint') ||
                  item.activityType !== 'LoginPoint') && (
                  <Tag>{item.totalPoint} Points</Tag>
                )}
              </div>
              {<h3>{item.title}</h3>}
              {item.isShowProgress && item.activityType !== 'OverallLQA' ? (
                <div
                  className={`progressbar-container ${
                    item.subTitle >= item.streak ? 'border-radius-show' : ''
                  }`}
                >
                  <progress
                    id="progress-bar"
                    max={item.streak}
                    value={
                      item.subTitle > item.streak ? item.streak : item.subTitle
                    }
                  >
                    Progress
                  </progress>
                  <label htmlFor="progress-bar" className="progressbar">
                    {`${
                      item.subTitle > item.streak ? item.streak : item.subTitle
                    }/${item.streak}`}
                  </label>
                </div>
              ) : (
                <p>{item.subTitle}</p>
              )}
            </DetailContainer>
          </Card>
        ))}
      {monthlyData &&
        Object.keys(monthlyData) &&
        Object.keys(monthlyData).find(
          (item) => currentMonth > Number(item)
        ) && (
          <div className="">
            <div className="d-flex space-between">
              <AchivementHeading> Archived Achievements </AchivementHeading>
              <span className="mr-22 mt-10">
                <Icon
                  height={17}
                  width={17}
                  kind={showArchiveData ? 'arrow-down' : 'arrow-right'}
                  onClick={() => {
                    SetShowArchiveData(!showArchiveData);
                  }}
                />
              </span>
            </div>
          </div>
        )}
      {showArchiveData &&
        Object.keys(monthlyData) &&
        Object.keys(monthlyData).map(
          (item, i) =>
            currentMonth > Number(item) && (
              <div>
                <Card className="archive-Card">
                  <img className="montlyColor" src={getMonthImage(item)} />
                  <TextContainer>
                    {months[Number(item)]} Challenges
                  </TextContainer>
                  <span className="mt-10">
                    <Icon
                      height={17}
                      width={17}
                      kind={
                        item === selectedMonth ? 'arrow-down' : 'arrow-right'
                      }
                      onClick={() =>
                        handleSetMonthData(item === selectedMonth ? 0 : item)
                      }
                    />
                  </span>
                </Card>
                {Object.entries(monthlyData).find(
                  ([key, val]: any) => item === key && key === selectedMonth
                ) && (
                  <div className="monthly-card">
                    <MonthlyCardContainer className="cards d-flex flex-wrap">
                      {monthlyData &&
                        Object.entries(monthlyData) &&
                        Object.entries(monthlyData).map(([key, item]: any) =>
                          item.map(
                            (mon) =>
                              key === selectedMonth && (
                                <MonthlyCardComponent
                                  image={getMonthImage(key)}
                                  data={mon}
                                  isShowBackgroudImage={true}
                                />
                              )
                          )
                        )}
                    </MonthlyCardContainer>
                  </div>
                )}
              </div>
            )
        )}

      {entityData && entityData.length > 0 && (
        <div className="entity-card">
          <div className="d-flex space-between">
            <AchivementHeading> My Achievements </AchivementHeading>
          </div>
          <MonthlyCardContainer className="cards d-flex flex-wrap">
            {entityData.map((item: any, index) => (
                <MonthlyCardComponent
                  key={index}
                  image={item.image}
                  data={item}
                  isShowBackgroudImage={false}
                />
              ))}
          </MonthlyCardContainer>
        </div>
      )}
    </CardContentContainer>
  );
};

export default AchivementCard;
